module.exports = __webpack_public_path__ + "img/campaign_int_black.96716181.svg";